import jwt from 'jsonwebtoken';
import loginUser from '../services/loginUser';
import storage from './storage';
import getConfig from '../config';
import { extractEmails } from './helpers';
import { initialQuery } from './api-request';
import { buildLoginPayload, closeWalletSelectorModal } from './near-utils';
import {
  FailedToCheckAccesskeyInNear, FailedToCreateProjectOperatorInNear, FailedToDecodeNearResponse,
  FailedToGetProjectOperator,
  UserHasNotVerified,
} from '../constans/constans';
import getProjectOperator from '../services/getProjectOperator';

const { indexerApi } = getConfig();
const haveProject = async (accountId) => {
  const body = { ...initialQuery,
    query: {
      bool: {
        must: [
          {
            match: {
              'signer_id.keyword': accountId,
            },
          },
        ],
      },
    } };
  try {
    const projects = await fetch(indexerApi, {
      method: 'POST',
      body: JSON.stringify({ ...body, from: 0 }),
    }).then((data) => data.json());
    return !!projects?.hits?.hits;
  } catch (e) {
    return false;
  }
};

export const checkingLogin = async (account, history, handleFunc = () => {}, login, update) => {
  if (!account?.accountId) return;
  const shouldAuthorize = storage.get('isSignIn') || login || !storage.get('token');
  if (!shouldAuthorize) return;

  storage.del('isSignIn');
  update('loading', true);
  try {
    const { accountId } = account;
    const loginPayload = await buildLoginPayload(account);
    if (!loginPayload) {
      update('loading', false);
      if (login) history.push('/login');
      return;
    }
    console.log(loginPayload,'loginPayload')
    console.log(account,'account')
    const register = await loginUser(loginPayload).catch((error) => {
      if (error.response) {
        const email = extractEmails(error.response.data.message);
        switch (error.response.data.status) {
          case UserHasNotVerified:
            return { email: email[0] };
          case FailedToCreateProjectOperatorInNear:
            return { email: email[0] };
          case FailedToDecodeNearResponse:
            return { email: email[0] };
          case FailedToGetProjectOperator:
            update('app.errors', { type: 1, text: 'This NEAR wallet is not connected to the OFP dashboard. Click on the Register button to register a new account.' });
            return false;
          case FailedToCheckAccesskeyInNear:
            history.push('/login');
            update('app.errors', { type: 3, text: 'This account is not permitted to access the dashboard. Please contact your forest project coordinator with any questions.' });
            return false;
          case 10804:
            update('app.errors', { type: 2, text: 'Sorry, we haven’t caught your NEAR access key. Please refresh the page. ' });
            return false;
          default:
            return false;
        }
      }
      return false;
    });
    if (register) {
      if (register.email) {
        update('loading', false);
        storage.set('emailUser', register.email);
        return history.push('/ready-page');
      }
      storage.set('token', register.data.token);
      const profile = await getProjectOperator();
      if (profile) {
        update('app.profile', profile.organization);
      }

      if (login) {
        update('loading', false);
        return handleFunc();
      }
      if (await haveProject(accountId)) {
        update('loading', false);
        return history.push('/');
      }
      update('loading', false);
      return history.push('/create-project');
    }
    if (login) {
      update('loading', false);
      return history.push('/login');
    }
  } finally {
    closeWalletSelectorModal();
  }
};

export const expireToken = (token) => {
  const decoded = jwt.decode(token);
  const dateNow = Date.now();
  const expireDate = Math.round(new Date(decoded?.ExpiredAt).getTime());

  return expireDate < dateNow;
};
